import { render, staticRenderFns } from "./sensitiveBlockedHeader.vue?vue&type=template&id=0ff164ba&scoped=true"
import script from "./sensitiveBlockedHeader.vue?vue&type=script&lang=js"
export * from "./sensitiveBlockedHeader.vue?vue&type=script&lang=js"
import style0 from "./sensitiveBlockedHeader.vue?vue&type=style&index=0&id=0ff164ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff164ba",
  null
  
)

export default component.exports